module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/login-layout/login-layout.component.html
// module id = ./src/app/core/components/login-layout/login-layout.component.html
// module chunks = main